module.exports = __webpack_public_path__ + "static/media/la2a-bg-1.14a2cca5.png";